const JosenFeaturesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4HpXDdjsCepoVmWt7LJLyv?si=93717e5dacba4466" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02eac330ad37d0953d938a76ab" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Gothnormie - NEMATODES (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5TgdN44gvyBk53GGTYjJBn?si=4777b42b513b4162" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e024506286616ec54ad77c41d32" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Ivanko - Hottest (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4OdIvZBRfzeZROBIzusuB7?si=8c6e5c6d695e418f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02122e45195d1c485c5a346f1e" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>kn1febaby - Ws (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>          

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2vkqPaPHiaRiEmlrtkARQj?si=15c26ec165154af2" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0274ce8b14387117ac4138c364" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>REROCK. - HOP OUT (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7GESdSsY3Buq9zuKa7gnTK?si=4b16c5efe24549d3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02661a8cf335824d47685a0f49" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>REROCK. - PICK A SIDE (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3k9r90ESy0oo0q8hnLENnz?si=d1172bd3c274409b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0282c7f0beffc4717784cabc53" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DamienPRIE$T - New York Flex (feat. Josen)</strong><br/>
                (prod. 730HAHAH)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/47oJ5zYZQCVdz6fxMsSazf?si=24a40317e731455f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0209cd92204db6799df2dc7b09" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Miami Dave - Mobb (feat. Josen)</strong><br/>
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/7BWuJJD9fvbpqQ8HRTePPj?si=7ec43658dba6437a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273200c87078b070d6ac16a2bdc" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Heems - Take Me (The Heights) (feat. Josen)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/bigbillsondeck/twotimes" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qaQc4G2G0Ro9Csfv-7xkavQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>POPSTARBILLS - TWO TIMES (feat. Josen & Zazbourne)</strong><br/>
              </p>
            </a>
          </div>    

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/dead2finesse/slum-josen-finessley" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-PlBAeeyl9CtAoHzi-vkrnxw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Finessley - Slum (feat. Josen)</strong><br/>
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/klassyofficial/stix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ccUlVePvQBUUS1zV-NsZCpw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Klassy - STIX (feat. Josen)</strong><br/>
                (prod. Cranky)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/30W3dRFY5TTds4GC6UpySG?si=f05370a332eb4c73" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2737541697374c32f7842d216d9" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don Da Menace - Digital Age (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>             

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/bigbillsondeck/yerrr-ft-josen-kasper-gem-prod" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-NNsIBEs2NVkhVgeh-YRYNBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>POPSTARBILLS - YERRR (feat. Josen & Kasper Gem)</strong><br/>
                (prod. POPSTARBILLS & Redluke)
              </p>
            </a>
          </div>  

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/752xtJbY3NKs3E25WjgxYb?si=58b99050faf347b5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02fc6c565454276a1d56745d30" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Miami Dave - GABAGOOL (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/kevinsavior/pop-rocks-popstarbills" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zum2kbeU4JprzXcw-I5SLIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kevin Hilfiger - poprocks (feat. POPSTARBILLS & Josen)</strong><br/>
                (prod. shy)
              </p>
            </a>
          </div>   

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/teardropdigital/josen-x-bill-mochi-pack-prod-brwnworld-teardrop-exclusive" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000653041048-yxgodj-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Josen & POPSTARBILLS - MOCHI PACK</strong><br/>
                (prod. Brwnworld)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3zXI0uxNFIX8HYrcOXRYoB?si=eb8fe46e818e460f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e026f387f82b8dc8e8078b537d8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Don Da Menace - Digital Age (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>                     

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/nostalgiacomo/no-surprises-feat-teven-cannon" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000534003885-8ohgxm-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Nostalgiac - No Surprises (feat. $teven Cannon, Lil Xelly & Josen)</strong><br/>
              </p>
            </a>
          </div>           

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/ihateyeoj/today-feat-jo-en-yeoj" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000483306537-pa4tb4-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yeoj - Today (feat. Josen)</strong><br/>
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/mudaico/braxton-knight-ape-escape-ft-josen-prod-hellasketchy" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000187454722-4c3mrw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Braxton Knight - Ape Escape (feat. Josen)</strong><br/>
                (prod. hellasketchy [RIP])
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default JosenFeaturesStatic;